export default __webpack_public_path__ + "static/media/rice3x.b7b0c60c.png";